import { gridConfig } from "lib/theme-new";
import styled from "styled-components";
import {
  alignItems,
  background,
  display,
  flex,
  flexDirection,
  height,
  justifyContent,
  maxHeight,
  maxWidth,
  minHeight,
  order,
  overflow,
  position,
  space,
  style,
  textAlign,
  width,
  zIndex,
} from "styled-system";

// Custom styled-system property:
const overflowY = style({
  prop: "overflowY",
  cssProperty: "overflow-y",
});

const {
  outerGutterWidths,
  innerGutterWidths,
  gridColumns,
  containerMaxWidths,
} = gridConfig;

const mapStyleProp = (prop, fn) =>
  Array.isArray(prop) ? prop.map(fn) : fn(prop);

export const Container = styled.div`
  ${space}
  ${maxWidth}
  ${height}
  ${width}
  ${position}
  ${textAlign}
  ${flex}
  ${overflow}
  ${background}
  ${display}
  ${minHeight}

  ${(p) => p.fluid && `max-width: none;`}
  ${(p) => p.relative && `position: relative;`}
`;
Container.defaultProps = {
  maxWidth: containerMaxWidths,
  px: mapStyleProp(outerGutterWidths, (w) => w),
  mx: "auto",
  width: "100%",
};

export const Row = styled.div.attrs({
  mx: innerGutterWidths.map((w) => `${w / -2}px`),
})`
  ${space}
  ${flex}
  ${justifyContent}
  ${alignItems}
  ${height}
  ${minHeight}
  ${display}

  flex-wrap: wrap;
`;
Row.defaultProps = {
  position: "relative",
  display: "flex",
};

export const RowCentered = styled(Row)`
  justify-content: center;
`;

export const Col = styled.div.attrs((p) => ({
  flex: p.span
    ? mapStyleProp(p.span, (s) => `0 0 ${(s / gridColumns) * 100}%`)
    : "1 0 0",
  order: p.order ? mapStyleProp(p.order, (o) => o) : 0,
  maxWidth: p.span
    ? mapStyleProp(p.span, (s) => `${(s / gridColumns) * 100}%`)
    : "100%",
  ml: p.offset
    ? mapStyleProp(p.offset, (o) => `${(o / gridColumns) * 100}%`)
    : 0,
}))`
  ${space}
  ${background}
  ${display}
  ${flex}
  ${order}
  ${height}
  ${maxWidth}
  ${maxHeight}
  ${minHeight}
  ${flexDirection}
  ${justifyContent}
  ${alignItems}
  ${textAlign}
  ${zIndex}
  ${position}
  ${overflowY}

  width: 100%;
`;
Col.defaultProps = {
  position: "relative",
  pr: innerGutterWidths.map((w) => `${w / 2}px`),
  pl: innerGutterWidths.map((w) => `${w / 2}px`),
};
